import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center d-flex pb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ma-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Strawberry Shortcake Jamz")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "ma-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Butter Cookie Jamz")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "ma-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Pleach Blush")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_nursing_task_list = _resolveComponent("nursing-task-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        class: "ma-2 rounded-xl",
        onClick: _ctx.all,
        variant: "tonal",
        color: "jamzcare"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Expand All ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_v_btn, {
        class: "ma-2 rounded-xl",
        onClick: _ctx.none,
        variant: "tonal",
        color: "jamzcare"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Collapse All ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_v_expansion_panels, {
      modelValue: _ctx.panel,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.panel) = $event)),
      multiple: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_expansion_panel, { value: "foo" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_expansion_panel_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_avatar, { image: "https://i.pravatar.cc/64" }),
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_v_expansion_panel_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_nursing_task_list)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_expansion_panel, { value: "bar" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_expansion_panel_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_avatar, { image: "https://i.pravatar.cc/65" }),
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_v_expansion_panel_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_nursing_task_list)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_expansion_panel, { value: "baz" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_expansion_panel_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_avatar, { image: "https://i.pravatar.cc/66" }),
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_v_expansion_panel_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_nursing_task_list)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}